import { ChevronRight } from "lucide-react-native";
import { FC } from "react";

import { HStack, Pressable, Text } from "@/components/ui";
import { FolderAncestor } from "@/types/resources";

interface FolderBreadcrumbProps {
  ancestors: FolderAncestor[];
  currentFolderName: string;
  onNavigate: (folderId: string | null) => void;
  rootLabel: string;
}

const FolderBreadcrumb: FC<FolderBreadcrumbProps> = ({
  ancestors,
  currentFolderName,
  onNavigate,
  rootLabel,
}) => {
  return (
    <HStack className="items-center gap-1 flex-wrap">
      <Pressable
        className="rounded px-1 -mx-1 hover:bg-primary-50"
        onPress={() => onNavigate(null)}
      >
        <Text className="text-base text-typography-500 font-medium hover:text-primary-600">
          {rootLabel}
        </Text>
      </Pressable>

      {ancestors.map((ancestor) => (
        <HStack className="items-center gap-1" key={ancestor.id}>
          <ChevronRight className="text-typography-300" size={16} />
          <Pressable
            className="rounded px-1 -mx-1 hover:bg-primary-50"
            onPress={() => onNavigate(ancestor.id)}
          >
            <Text
              className="text-base text-typography-500 font-medium hover:text-primary-600"
              numberOfLines={1}
            >
              {ancestor.name}
            </Text>
          </Pressable>
        </HStack>
      ))}

      <HStack className="items-center gap-1">
        <ChevronRight className="text-typography-300" size={16} />
        <Text
          className="text-base text-primary-600 font-semibold"
          numberOfLines={1}
        >
          {currentFolderName}
        </Text>
      </HStack>
    </HStack>
  );
};

export default FolderBreadcrumb;
